import { workspaceQueryKeys as e } from "./useWorkspaceQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { authApi as r } from "@maat/api-main";
//#region src/workspaces/useUpdateMemberPermissionsMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: ({ userId: e, data: t }) => r.assignPermissions(e, t),
		onSuccess: (t, { userId: n }) => {
			i.invalidateQueries({ queryKey: e.memberPermissions(n) }), i.invalidateQueries({ queryKey: e.members() });
		}
	});
};
//#endregion
export { i as useUpdateMemberPermissionsMutation };
